import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-aspect-ratio",
  templateUrl: "./med-icon-aspect-ratio.component.html",
})
export class MedIconAspectRatioComponent extends SvgMixinComponent {}
